module.exports = __webpack_public_path__ + "img/product_12.0798c91.jpg";